import React, { useState, useEffect } from 'react';
import { Languages, CircleDot, X } from 'lucide-react';
import './styles/LanguageDropdown.css';

const languages = [
  { code: 'bn-IN', name: 'Bengali' },
  { code: 'en-IN', name: 'English' },
  { code: 'gu-IN', name: 'Gujarati' },
  { code: 'hi-IN', name: 'Hindi' },
  { code: 'kn-IN', name: 'Kannada' },
  { code: 'ml-IN', name: 'Malayalam' },
  { code: 'mr-IN', name: 'Marathi' },
  { code: 'pa-IN', name: 'Punjabi' },
  { code: 'ta-IN', name: 'Tamil' },
  { code: 'te-IN', name: 'Telugu' },
  { code: 'ur-IN', name: 'Urdu' }
];

const LanguageDropdown = (props) => {
  const [temporarySelection, setTemporarySelection] = useState('hi-IN');

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        props.onSelectLanguage({ action: 'yes', slectLan: temporarySelection });
      } else if (e.key === 'Escape') {
        e.preventDefault();
        props.onSelectLanguage({ action: 'no', slectLan: temporarySelection });
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [temporarySelection, props]);

  return (
    <div className="language-select-overlay">
      <div className="language-select-modal">
        {/* Icon at top */}
        <div className="language-select-icon-circle">
          <Languages className="language-select-icon" size={40} />
        </div>

        {/* Heading */}
        <h2 className="language-select-heading">
          Recording Language Select
        </h2>

        {/* Description */}
        <p className="language-select-description">
          Please choose the transliteration language
        </p>

        {/* Sub text */}
        <p className="language-select-subtext">
          for your recorded video
        </p>

        {/* Language list */}
        <div className="language-select-list">
          {languages.map((lang) => (
            <label
              key={lang.code}
              className={`language-select-item ${temporarySelection === lang.code ? 'selected' : ''}`}
              htmlFor={lang.code}
            >
              <input
                type="radio"
                id={lang.code}
                name="language"
                value={lang.code}
                checked={temporarySelection === lang.code}
                onChange={(e) => setTemporarySelection(e.target.value)}
                className="language-select-radio"
              />
              <CircleDot 
                size={18} 
                className={`language-select-radio-icon ${temporarySelection === lang.code ? 'checked' : ''}`}
              />
              <span className="language-select-name">{lang.name}</span>
            </label>
          ))}
        </div>

        {/* Buttons */}
        <div className="language-select-buttons">
          <button
            onClick={() => {
              props.onSelectLanguage({ action: 'yes', slectLan: temporarySelection });
            }}
            className="language-select-btn-start"
          >
            <span>Start Recording</span>
          </button>
          <button
            onClick={() => {
              props.onSelectLanguage({ action: 'no', slectLan: temporarySelection });
            }}
            className="language-select-btn-cancel"
          >
            <X size={20} />
            <span>Cancel</span>
          </button>
        </div>

        {/* Footer hint */}
        <p className="language-select-footer">
          Press Enter to start • Escape to cancel
        </p>
      </div>
    </div>
  );
}

export default LanguageDropdown;
